export enum SupportedLocale {
  EN = "en",
  RU = "ru",
  EL = "el",
  FR = "fr",
  AR = "ar",
  ES = "es",
}

// All possible locales (used for types and validation)
export const AllSupportedLocales = [
  SupportedLocale.EN,
  SupportedLocale.RU,
  SupportedLocale.EL,
  SupportedLocale.FR,
  SupportedLocale.AR,
  SupportedLocale.ES,
];

export const LocaleToLabelMap: Map<SupportedLocaleType, string> = new Map([
  [SupportedLocale.EN, "ENG"],
  [SupportedLocale.RU, "РУС"],
  [SupportedLocale.EL, "ΕΛΛ"],
  [SupportedLocale.FR, "FRA"],
  [SupportedLocale.AR, "العربية"],
  [SupportedLocale.ES, "ESP"],
]);

export type SupportedLocaleType = (typeof AllSupportedLocales)[number];
